import { Grid, FormControl, Select, MenuItem, TextField, Button, Typography } from "@mui/material";
import { auditReasons } from "../../utility";
import { useAppDispatch, useAppSelector } from "../../redux";
import {
  getCaseForReviewAction,
  selectAttempts,
  selectAuditComment,
  selectAuditDecision,
  selectAuditReason,
  selectClaimType,
  selectQueueType,
  setAuditComment,
  setAuditDecision,
  setAuditReason,
  setQueueTypeAction,
  submitDecisionAction,
} from "./QueueSlice";
import { IAttempt } from "../../types/images";
import { Statuses } from "../../constants";
import { useEffect, useState } from "react";

interface ReasonsModalProps {
  handleClose(): void;
}

export function ReasonsModal(props: ReasonsModalProps) {
  const { handleClose } = props;
  const [err, setErr] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const decision = useAppSelector(selectAuditDecision);
  const comment = useAppSelector(selectAuditComment);
  const reasonType = decision === Statuses.approved ? Statuses.approved : "a2review";
  const { reasons } = auditReasons;
  const attempts = useAppSelector(selectAttempts);
  const isAuthentication = (attempts as IAttempt[])[0].info.Verification_Type;
  const _reasons = isAuthentication
    ? reasons.verification[reasonType as "approved" | "a2review"]
    : reasons.registration[reasonType as "approved" | "a2review"];
  const reason = useAppSelector(selectAuditReason);
  const queueType = useAppSelector(selectQueueType);
  const claimType = useAppSelector(selectClaimType);

  useEffect(() => {
    if (reason || comment) {
      setErr(null);
    }
  }, [reason, comment]);

  const submitDecision = async () => {
    if (!reason) return setErr("Plase select a reason for your decision");
    if (reason === "Other" && !comment) {
      return setErr("Please add a reason for your decision");
    }
    const args = {
      queueType: queueType as string,
      attempts: attempts as IAttempt[],
      decision: decision as string,
      reason: reason as string,
      varification: isAuthentication,
      comment,
    };

    await dispatch(submitDecisionAction(args));
    dispatch(setAuditDecision(null));
    dispatch(setAuditReason(null));
    if (comment) dispatch(setAuditComment(null));
    handleClose();

    const _queueType = queueType === "paneem" ? queueType : "SP";

    await dispatch(
      getCaseForReviewAction({
        queueType: _queueType as string,
        claimType: claimType as string,
        userInfoId: (attempts as IAttempt[])[0].details.userInfoId,
        regNum: (attempts as IAttempt[])[0].info.Registration_Number,
      })
    );
  };

  return (
    <FormControl variant="outlined" sx={{ width: "100%" }}>
      <Select
        value={reason}
        onChange={(e) => dispatch(setAuditReason(e.target.value))}
        sx={{ minHeight: "56px", textAlign: "center" }}
      >
        {_reasons.map((reason) => (
          <MenuItem value={reason.value} key={reason.value}>
            {reason.type} - {reason.value}
          </MenuItem>
        ))}

        <MenuItem value="Other">Other</MenuItem>
      </Select>
      {reason === "Other" ? (
        <TextField
          value={comment}
          onChange={(e) => {
            dispatch(setAuditComment(e.target.value));
          }}
          label={"comment"}
          sx={{ width: "100%", marginTop: 3 }}
        />
      ) : null}
      {err ? <Typography color="red">{err}</Typography> : null}
      <Button variant="contained" onClick={submitDecision} sx={{ marginTop: 3 }}>
        Submit Decision
      </Button>

      <Button variant="outlined" onClick={handleClose} sx={{ marginTop: 3 }}>
        Cancel
      </Button>
    </FormControl>
  );
}
